import React from 'react';
import Input from '../Input';
import Select from '../Select';

const states = [
  { value: 'AK', text: 'AK - Alaska' },
  { value: 'AL', text: 'AL - Alabama' },
  { value: 'AR', text: 'AR - Arkansas' },
  { value: 'AZ', text: 'AZ - Arizona' },
  { value: 'CA', text: 'CA - California' },
  { value: 'CO', text: 'CO - Colorado' },
  { value: 'CT', text: 'CT - Connecticut' },
  { value: 'DC', text: 'DC - District Of Columbia' },
  { value: 'DE', text: 'DE - Delaware' },
  { value: 'FL', text: 'FL - Florida' },
  { value: 'GA', text: 'GA - Georgia' },
  { value: 'HI', text: 'HI - Hawaii' },
  { value: 'IA', text: 'IA - Iowa' },
  { value: 'ID', text: 'ID - Idaho' },
  { value: 'IL', text: 'IL - Illinois' },
  { value: 'IN', text: 'IN - Indiana' },
  { value: 'KS', text: 'KS - Kansas' },
  { value: 'KY', text: 'KY - Kentucky' },
  { value: 'LA', text: 'LA - Louisiana' },
  { value: 'MA', text: 'MA - Massachusetts' },
  { value: 'MD', text: 'MD - Maryland' },
  { value: 'ME', text: 'ME - Maine' },
  { value: 'MI', text: 'MI - Michigan' },
  { value: 'MN', text: 'MN - Minnesota' },
  { value: 'MO', text: 'MO - Missouri' },
  { value: 'MS', text: 'MS - Mississippi' },
  { value: 'MT', text: 'MT - Montana' },
  { value: 'NC', text: 'NC - North Carolina' },
  { value: 'ND', text: 'ND - North Dakota' },
  { value: 'NE', text: 'NE - Nebraska' },
  { value: 'NH', text: 'NH - New Hampshire' },
  { value: 'NJ', text: 'NJ - New Jersey' },
  { value: 'NM', text: 'NM - New Mexico' },
  { value: 'NV', text: 'NV - Nevada' },
  { value: 'NY', text: 'NY - New York' },
  { value: 'OH', text: 'OH - Ohio' },
  { value: 'OK', text: 'OK - Oklahoma' },
  { value: 'OR', text: 'OR - Oregon' },
  { value: 'PA', text: 'PA - Pennsylvania' },
  { value: 'RI', text: 'RI - Rhode Island' },
  { value: 'SC', text: 'SC - South Carolina' },
  { value: 'SD', text: 'SD - South Dakota' },
  { value: 'TN', text: 'TN - Tennessee' },
  { value: 'TX', text: 'TX - Texas' },
  { value: 'UT', text: 'UT - Utah' },
  { value: 'VA', text: 'VA - Virginia' },
  { value: 'VT', text: 'VT - Vermont' },
  { value: 'WA', text: 'WA - Washington' },
  { value: 'WI', text: 'WI - Wisconsin' },
  { value: 'WV', text: 'WV - West Virginia' },
  { value: 'WY', text: 'WY - Wyoming' }
];

function SubscribeAddress({ size, state, errors, onChange }) {
  let cityState;

  if (size === 'desktop') {
    cityState = (
      <div className="short-div">
        <Select autoComplete="address-level1" className={`subscribe-${size}-input-state`} error={errors.state} name="state" label="State" placeholder="Select State" value={state.state} onChange={onChange} choices={states} inline />
        <Input type="text" autoComplete="postal-code" className={`subscribe-${size}-input-zip`} error={errors.zip} name="zip" label="Zip Code" placeholder="12345" value={state.zip} onChange={onChange} inline />
      </div>
    );
  } else {
    cityState = (
      <React.Fragment>
        <Select autoComplete="address-level1" className={`subscribe-${size}-input-state`} error={errors.state} name="state" label="State" placeholder="Select State" value={state.state} onChange={onChange} choices={states} />
        <Input type="text" autoComplete="postal-code" className={`subscribe-${size}-input-zip`} error={errors.zip} name="zip" label="Zip Code" placeholder="12345" value={state.zip} onChange={onChange} />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Input type="text" autoComplete="street-address" className={`subscribe-${size}-input-address`} error={errors.address} name="address" label="Address" placeholder="123 Canned Corn Way" value={state.address} onChange={onChange} />
      <Input type="text" autoComplete="address-level2" className={`subscribe-${size}-input-city`} error={errors.city} name="city" label="City" placeholder="Pasadena" value={state.city} onChange={onChange} />
      {cityState}
    </React.Fragment>
  );
}

export default SubscribeAddress;
